import { Button } from '@naf-simba/elements-buttons';
import { simbaStyled } from '@naf-simba/theme';
import { nafColor } from '@nafcore/theme';
import { spacing } from '@naf/theme';

export const NavbarLinkButton = simbaStyled<typeof Button, Record<string, never>>(Button)(() => ({
  '&&': {
    backgroundColor: 'transparent',
    color: nafColor.signature.black,
    padding: `0 ${spacing.space8}`,

    '& .naf-ButtonLabel': {
      fontSize: '1rem',
    },

    '&:hover': {
      backgroundColor: nafColor.signature.yellow40,
      color: nafColor.signature.black,
      textDecoration: 'none',
    },
  },
}));
